import { AvailableIcons } from '@asn/icon';

import { Component, OnInit, ViewEncapsulation, output, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import '@asn/badge';
import '@asn/icon';

import { NavigationItem, NavigationType } from '../header.model';

@Component({
    selector: 'ap-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgTemplateOutlet],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApMenuItemComponent implements OnInit {
    /**
     * Required - The navigation item
     */
    public readonly navigationItem = input.required<NavigationItem>();

    /**
     * Whether to include the parent in the click of the item.
     * Defaults to false
     */
    public readonly includeParent = input(false);

    /**
     * emits when the NavigationItem is clicked
     */
    public readonly navigationClicked = output<NavigationItem>();

    public navigationType = NavigationType;

    // Temporary fix. Remove A19
    ngOnInit() {
        const navigationItem = this.navigationItem();
        if (navigationItem.iconName !== null) {
            navigationItem.iconName = navigationItem.label as AvailableIcons;
        }
    }
}
